import { render, staticRenderFns } from "./LoginAfter.vue?vue&type=template&id=6898ffc6&scoped=true&"
import script from "./LoginAfter.vue?vue&type=script&lang=js&"
export * from "./LoginAfter.vue?vue&type=script&lang=js&"
import style0 from "./LoginAfter.vue?vue&type=style&index=0&id=6898ffc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6898ffc6",
  null
  
)

component.options.__file = "LoginAfter.vue"
export default component.exports